<ng-container *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewMultipleChoiceTypes.singleSelect">
    <mat-radio-group class="vertical" [attr.aria-labelledby]="ariaLabelledBy">
        <mat-radio-button
            *ngFor="let value of interviewQuestion.questionValues"
            [value]="value"
            class="margin-left-2"
            required
            >{{ value }}</mat-radio-button
        >
    </mat-radio-group>
</ng-container>
<div
    *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewMultipleChoiceTypes.multiSelect"
    role="group"
    [attr.aria-labelledby]="ariaLabelledBy"
>
    <div *ngFor="let value of interviewQuestion.questionValues">
        <mat-checkbox class="margin-left-2"> {{ value }} </mat-checkbox>
    </div>
</div>
